export default __webpack_public_path__ + "static/media/inProgress.f52fdd74.webp";